import {Injectable} from '@angular/core';
import {Http, RequestMethod, RequestOptions, Response, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';


const SAVE_GUIDE = 'api/save-guide';

@Injectable()
export class BackendService {

  constructor(private http: Http) {
  }

  private getJsonFilename(guideId: string): string {
    return 'assets/guides/' + guideId + '/guide.json'
  }

  public loadGuideJson(guideId: string): Observable<Response> {
    const filename = this.getJsonFilename(guideId);
    return this.http.get(filename);
  }

  public updateGuide(guideId: string, guideJson: string) {
    console.log('update guide: ', guideJson);
    const postHeaders = new Headers({'Content-Type': 'application/json'});
    const options = new RequestOptions({
      method: RequestMethod.Post,
      headers: postHeaders
    });
    const resp: Observable<Response> = this.http.post(SAVE_GUIDE, guideJson, options);
    resp.subscribe(r => console.log('Response: ', r));
  }

}




// WEBPACK FOOTER //
// C:/Users/muth/Documents/privat/angular/guidr/src/app/services/backend.service.ts